import {
  getSelectedProduct,
  loadProducts,
  loadProductsRegistry,
  selectProduct,
  selectProductByKey,
} from '@americanexpress/product-ducks';

export const loadProductsData = (store) => {
  const { dispatch, getState } = store;
  return async (nextState, replace, callback) => {
    try {
      await dispatch(loadProductsRegistry());
      const state = getState();
      const isLoggedIn = Boolean(getSelectedProduct(state));
      if (isLoggedIn) {
        await dispatch(loadProducts());

        const accountKeyQueryParam = nextState?.location?.query?.account_key;
        const opaqueAccountId = nextState?.location?.query?.opaqueAccountId;
        if (accountKeyQueryParam) {
          dispatch(selectProductByKey(accountKeyQueryParam));
        }
        if (opaqueAccountId) {
          dispatch(selectProduct(opaqueAccountId));
        }
      }

      return callback();
    } catch {
      return callback();
    }
  };
};
